import { formatDateForInput, calculateAgeFromDob } from './patientFormHelpers';

export function mapUserToForm(user) {
  if (!user) return {};
  const dateOfBirth = formatDateForInput(user.date_of_birth);
  const ageYears = dateOfBirth
    ? (user.age_years ?? calculateAgeFromDob(dateOfBirth))
    : (user.age_years ?? '');

  return {
    user_id: user.user_id,
    user_type_id: user.user_type_id ?? '',
    user_name: user.user_name || '',
    profile_pic_path: user.profile_pic_path || '',
    date_of_birth: dateOfBirth,
    age_years: ageYears,
    gender: user.gender || '',
    phone_number: user.phone_number || '',
    country_code: user.country_code || '',
    email_address: user.email_address || '',
    country_id: user.country_id ?? '',
    location_id: user.location_id ?? '',
    comments: user.comments || '',
    establishment_id: user.establishment_id ?? '',
    user_type: user.user_type || '',
    country_name: user.country_name || '',
    location_name: user.location_name || '',
    establishment_name: user.establishment_name || '',
  };
}

export const emptyUserForm = () => mapUserToForm({});
